import script from "./AddMedicationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddMedicationForm.vue?vue&type=script&setup=true&lang=ts"

import "./AddMedicationForm.vue?vue&type=style&index=0&id=f1434ebe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1434ebe"]])

export default __exports__